// 品种页面
export const KIND_PAGE_UUID = '1deeebd1-1feb-4967-b591-59aa3f6e05b8'

// 管理品种
export const KIND_ACTION_UUID = '7cd9fa87-0af9-4df9-926b-28531a4d5f23'
